module.exports = __webpack_public_path__ + "img/ft.3228fc05.png";